import { inject, signal, Signal } from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_AUTHORIZATION, AuthorizationStore } from '@softline/auth';

export function authorizationFn(): (permission: string) => Signal<boolean> {
  const store = inject(Store);
  return (permission: string) => {
    return signal(store.get(SOFTLINE_FEATURE_AUTHORIZATION, AuthorizationStore.getters.authorized, permission));
  }
}
